import Joi from "joi-browser";

function nameValidation(errors) {
    let stringError = "";
    let err = errors[0];
    switch (err.type) {
        case "string.max":
            stringError = `can't exceed ${err.context.limit} letters.`;
            break;
        case "string.min":
            stringError = `can't be less than ${err.context.limit} letters.`;
            break;
        case "any.empty":
            stringError = "can't be an empty field.";
            break;
        default:
            stringError = "is required";
    }

    return {
        template: " {{message}}",
        context: {
            errors: errors.length,
            message: stringError,
        },
    };
}

const requiredErrorMessage = (errors) => {
    return {
        template: " {{message}}",
        context: {
            errors: errors.length,
            message: "is required",
        },
    };
};

const AddUserSchema = Joi.object().keys({
    firstname: Joi.string()
        .trim()
        .max(256)
        .min(2)
        .required()
        .label("First Name")
        .error((errors) => {
            return nameValidation(errors);
        }),
    lastname: Joi.string()
        .trim()
        .max(256)
        .min(2)
        .required()
        .label("Last Name")
        .error((errors) => {
            return nameValidation(errors);
        }),
    email: Joi.string()
        .regex(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        )
        .required()
        .label("Email")
        .error((errors) => {
            function errorsAsString() {
                let err = errors[0];
                switch (err.type) {
                    case "any.empty":
                        return "can't be an empty field.";
                    case "string.regex.base":
                        return "should be somthing like this: example@abc.com";
                }
            }
            return {
                template: " {{message}}",
                context: {
                    errors: errors.length,
                    message: errorsAsString(),
                },
            };
        }),
    organizationId: Joi.when(Joi.ref("$isSuperAdmin"), {
        is: false,
        then: Joi.string()
            .required()
            .label("Organization")
            .error((errors) => {
                return requiredErrorMessage(errors);
            }),
    }),
    role: Joi.when(Joi.ref("$isSuperAdmin"), {
        is: false,
        then: Joi.string()
            .required()
            .label("Role")
            .error((errors) => {
                return requiredErrorMessage(errors);
            }),
    }),
    password: Joi.string()
        .min(8)
        .regex(/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?\d)(?=.*?[!@#$%^&*.]).{8,}$/)
        .when(Joi.ref("$isPasswordRequired"), {
            is: true,
            then: Joi.required(),
        })
        .label("Password")
        .error((errors) => {
            function errorsAsString() {
                let err = errors[0];
                switch (err.type) {
                    case "string.min":
                        return `must be more than or equal ${err.context.limit} letters.`;
                    case "string.regex.base":
                        return "should contain at least 1 small letter, 1 capital letter, 1 number and 1 special character.";
                    default:
                        return "is required";
                }
            }
            return {
                template: " {{message}}",
                context: {
                    errors: errors.length,
                    message: errorsAsString(),
                },
            };
        }),
    passwordConfirmation: Joi.any()
        .valid(Joi.ref("password"))
        .when(Joi.ref("$isPasswordRequired"), {
            is: true,
            then: Joi.required(),
        })
        .options({ language: { any: { allowOnly: "must match password" } } })
        .label("Confirm Password"),
});

const EditUserSchema = Joi.object().keys({
    firstname: Joi.string()
        .trim()
        .max(256)
        .min(2)
        .required()
        .label("First Name")
        .error((errors) => {
            return nameValidation(errors);
        }),

    lastname: Joi.string()
        .trim()
        .max(256)
        .min(2)
        .required()
        .label("Last Name")
        .error((errors) => {
            return nameValidation(errors);
        }),
});

const ChangePasswordSchema = Joi.object().keys({
    oldPassword: Joi.string().required().label("Old Password"),

    newPassword: Joi.string()
        .min(8)
        .regex(/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?\d)(?=.*?[!@#$%^&*.]).{8,}$/)
        .required()
        .label("New Password")
        .error((errors) => {
            function errorsAsString() {
                let err = errors[0];
                switch (err.type) {
                    case "string.min":
                        return `must be more than or equal ${err.context.limit} letters.`;
                    case "string.regex.base":
                        return "should contain at least 1 small letter, 1 capital letter, 1 number and 1 special character.";
                    default:
                        return "is required";
                }
            }
            return {
                template: " {{message}}",
                context: {
                    errors: errors.length,
                    message: errorsAsString(),
                },
            };
        }),

    newPasswordConfirmation: Joi.any()
        .valid(Joi.ref("newPassword"))
        .required()
        .options({ language: { any: { allowOnly: "must match password" } } })
        .label("Confirm Password"),
});

const changeQuestionSchema = Joi.object().keys({
    password: Joi.string()
        .min(8)
        .regex(/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?\d)(?=.*?[!@#$%^&*.]).{8,}$/)
        .required()
        .label("Current Password")
        .error((errors) => {
            function errorsAsString() {
                let err = errors[0];
                switch (err.type) {
                    case "string.min":
                        return `must be more than or equal ${err.context.limit} letters.`;
                    case "string.regex.base":
                        return "should contain at least 1 small letter, 1 capital letter, 1 number and 1 special character.";
                    default:
                        return "is required";
                }
            }
            return {
                template: " {{message}}",
                context: {
                    errors: errors.length,
                    message: errorsAsString(),
                },
            };
        }),

    recoveryQuestion: Joi.string().trim().required().label("Recovery Question"),
    answer: Joi.string().trim().required().label("Recovery Question"),
});

export default {
    AddUserSchema,
    EditUserSchema,
    ChangePasswordSchema,
    changeQuestionSchema,
};
